<template>
  <div>
    <div class="alert alert-success" v-if="success">
      <h4 class="alert-heading">Vielen Dank!</h4>
      <p>
        Ihr Gutschein wurde erfolgreich eingelöst. Sie erhalten in Kürze eine
        Bestätigung per E-Mail.
      </p>
    </div>
    <form
      @submit.prevent="submitForm"
      class="p-4 bg-light border rounded"
      v-if="!success"
    >
      <small class="d-block mb-3 text-danger"> * Pflichtfelder </small>
      <!-- Gutscheincode -->
      <div class="form-group">
        <label for="couponCode"
          ><span class="text-danger">*</span>Gutscheincode:</label
        >
        <input
          type="text"
          id="couponCode"
          v-model="form.couponCode"
          class="form-control"
          readonly
        />
      </div>

      <div class="row">
        <div class="col-md-6">
          <!-- Anreisedatum -->
          <div class="form-group">
            <label for="arrivalDate"
              ><span class="text-danger">*</span>Anreisedatum:</label
            >
            <input
              type="date"
              id="arrivalDate"
              v-model="form.arrivalDate"
              class="form-control"
              required
            />
          </div>
        </div>

        <div class="col-md-6">
          <!-- Abreisedatum -->
          <div class="form-group">
            <label for="departureDate"
              ><span class="text-danger">*</span>Abreisedatum:</label
            >
            <input
              type="date"
              id="departureDate"
              v-model="form.departureDate"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>

      <!-- Reisender -->
      <div
        v-for="(traveler, index) in form.travelers"
        :key="index"
        class="mb-4 p-3 border rounded bg-white"
      >
        <h5>Reisender {{ index + 1 }}</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="firstName"
                ><span class="text-danger">*</span>Vorname:</label
              >
              <input
                type="text"
                v-model="traveler.firstName"
                class="form-control"
                required
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="lastName"
                ><span class="text-danger">*</span>Nachname:</label
              >
              <input
                type="text"
                v-model="traveler.lastName"
                class="form-control"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="birthDate"
            ><span class="text-danger">*</span>Geburtsdatum:</label
          >
          <input
            type="date"
            v-model="traveler.birthDate"
            class="form-control"
            required
          />
        </div>
        <button
          v-if="form.travelers.length > 2"
          @click.prevent="removeTraveler(index)"
          class="btn btn-danger btn-sm"
        >
          - Person entfernen
        </button>
      </div>

      <!-- Add Traveler Button -->
      <button @click.prevent="addTraveler" class="btn btn-primary mb-4">
        + Weitere Person hinzufügen
      </button>

      <!-- Telefonnummer -->
      <div class="form-group">
        <label for="phone"
          ><span class="text-danger">*</span>Telefonnummer:</label
        >
        <input
          type="tel"
          id="phone"
          v-model="form.phone"
          class="form-control"
          required
        />
      </div>

      <!-- E-Mail-Adresse -->
      <div class="form-group">
        <label for="email"
          ><span class="text-danger">*</span>E-Mail-Adresse:</label
        >
        <input
          type="email"
          id="email"
          v-model="form.email"
          class="form-control"
          required
        />
      </div>

      <!-- Anmerkungen -->
      <div class="form-group">
        <label for="notes">Anmerkungen (optional):</label>
        <textarea
          id="notes"
          v-model="form.notes"
          class="form-control"
          rows="3"
        ></textarea>
      </div>

      <!-- Checkbox for AGBs und dass die Einlösung verbindlich und nicht stornierbar ist. -->
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          v-model="form.agb"
          id="agb"
          required
        />
        <label class="form-check-label" for="agb">
          Ich habe die <a href="/agb" target="_blank">AGBs</a> gelesen und
          akzeptiere, dass die Einlösung verbindlich und nicht stornierbar ist.
        </label>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-lg btn-block btn-primary mt-3">
        Verbindlich einlösen
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['couponCode', 'submitUrl'],
  data() {
    return {
      form: {
        form: 'heidepark',
        couponCode: this.couponCode,
        arrivalDate: '',
        departureDate: '',
        travelers: [
          { firstName: '', lastName: '', birthDate: '' },
          { firstName: '', lastName: '', birthDate: '' },
        ],
        phone: '',
        email: '',
        notes: '',
        agb: false,
      },
      success: false,
    }
  },
  methods: {
    addTraveler() {
      this.form.travelers.push({ firstName: '', lastName: '', birthDate: '' })
    },
    removeTraveler(index) {
      if (this.form.travelers.length > 2) {
        this.form.travelers.splice(index, 1)
      }
    },
    submitForm() {
      if (
        new Date(this.form.arrivalDate) >= new Date(this.form.departureDate)
      ) {
        alert('Das Abreisedatum muss nach dem Anreisedatum liegen.')
        return
      }

      //   Alert if agb not agreed
      if (!this.form.agb) {
        alert('Bitte akzeptieren Sie die AGBs.')
        return
      }

      var self = this
      axios
        .post(this.submitUrl, this.form)
        .then((response) => {
          // Set success
          self.success = true
        })
        .catch((error) => {
          console.error(error)
          alert('Fehler beim Abschicken des Formulars.')
        })
    },
  },
}
</script>

<style scoped>
/* Add any additional styling as needed */
</style>
